import { render, staticRenderFns } from "./menu-edit.vue?vue&type=template&id=a9a4b73e&scoped=true&"
import script from "./menu-edit.vue?vue&type=script&lang=js&"
export * from "./menu-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=a9a4b73e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a4b73e",
  null
  
)

component.options.__file = "menu-edit.vue"
export default component.exports